<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/raafRo/tc-custom/9781633224643.jpg?1699516179436" alt="This image is the cover for the book Folk Art Fusion: Americana"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Folk Art Fusion: Americana
      </h1>
      <p class="bookDescription body article font2">
        <b>Fans of Charles Wysocki, Mary Engelbreit, Grandma Moses, and folk art in general will fall in love with this guide to painting, organized by seasons.</b><br/><br/>Featuring projects that instruct artists of all skill levels how to draw and paint subjects that include quaint homes, pretty patterns, colorful gardens, picturesque farms, beautiful birds, and textured florals, this book features American-themed folk art infused with a modern twist.<br/><br/>Beginning with an overview of what folk art is, followed by introductory topics like color, tools and materials, and drawing and painting techniques, <i>Folk Art Fusion: Americana</i> also includes sixteen simple step-by-step projects done in approachable and popular mediums. Rounding out the book is a gallery of folk-art pieces sure to inspire lovers of all things Americana.<br/><br/>Simultaneously fresh and nostalgic, <i>Folk Art Fusion: Americana</i> draws on America’s rich artistic tradition and heritage and provides a fun, accessible take on creating beloved scenes from the heartland.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joy Laforme
      </h2>
      
      <p class="authorDescription body article">Joy Laforme is a self-taught illustrator and an artist with an M.A. in interactive design from the Savannah College of Art and Design. Born and raised in the Hudson Valley in New York, Joy eventually settled in a small town outside New York City near the Ramapo Mountains. Her mother's love of all things Americana and garden have informed Joy's contemporary folk art style and her work with brands, publishers, and print publications. She works in a variety of mediums, including digital, gouache, and pastel. For more work, please visit www.joylaforme.com, and follow her on Instagram and Pinterest @joylaforme for the newest available artwork and behind-the-scenes images.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Walter Foster Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0ba3dd78